<template>
  <VAutocompleteWithValidation
    v-model="innerValue"
    label="Vyhledat zákazníka"
    rules="required"
    :items="innerItems"
    item-text="fullName"
    item-value="id"
    :search-input.sync="search"
    :loading="loading"
    :custom-slot="true"
    outlined
    dense
    :clearable="true"
    v-on="$listeners"
  >
    <template slot="item" slot-scope="{ item }">
      <span v-if="contact && item.phone && item.email">
        {{ item.id }} - {{ item.fullName }}, {{ item.phone }}, {{ item.email }}</span
      >
      <span v-else-if="contact && item.phone">
        {{ item.id }} - {{ item.fullName }}, {{ item.phone }}</span
      >
      <span v-else-if="contact && item.email">
        {{ item.id }} - {{ item.fullName }}, {{ item.email }}</span
      >
      <span v-else> {{ item.id }} - {{ item.fullName }} </span>
    </template>
    <template slot="selection" slot-scope="{ item }">
      <span v-if="contact && item.phone && item.email">
        {{ item.id }} - {{ item.fullName }}, {{ item.phone }}, {{ item.email }}</span
      >
      <span v-else-if="contact && item.phone">
        {{ item.id }} - {{ item.fullName }}, {{ item.phone }}</span
      >
      <span v-else-if="contact && item.email">
        {{ item.id }} - {{ item.fullName }}, {{ item.email }}</span
      >
      <span v-else> {{ item.id }} - {{ item.fullName }} </span>
    </template>
  </VAutocompleteWithValidation>
</template>

<script>
import { mapActions } from 'vuex'
import VAutocompleteWithValidation from '@/components/validators/VAutocompleteWithValidation'

export default {
  name: 'CustomerAutocomplete',
  components: { VAutocompleteWithValidation },
  props: {
    value: {
      type: null,
    },
    items: {
      type: Array,
      default: () => [],
    },
    contact: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    innerValue: '',
    innerItems: [],
    search: '',
    loading: false,
  }),
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit('input', newVal)
    },
    innerItems(newVal) {
      this.$emit('items', newVal)
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal
    },
    items(newVal) {
      this.innerItems = newVal
    },
    search(value) {
      if (typeof this.value === 'number') {
        return
      }
      if (!value || !value.length) {
        this.searchCustomer(value, true)
      } else {
        this.searchCustomer(value, false)
      }
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value
    }
    if (this.items) {
      this.innerValue = this.items
    }
    this.searchCustomer('', true)
  },
  methods: {
    ...mapActions({
      searchCustomers: 'customer/searchCustomers',
    }),
    searchCustomer(value, initial) {
      if (this.cancel) {
        this.cancel()
        this.cancel = null
      }
      if (!value && !initial) {
        return
      }
      let query = {}
      if (initial) {
        query['size'] = 25
      } else {
        query['searchTerm'] = value
      }
      const searchParams = {
        filterParams: query,
      }
      this.loading = true
      this.searchCustomers(searchParams)
        .then((response) => {
          this.innerItems = response.data.items
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
